export default "__VITE_ASSET__DWb_2PNB__"